<template>
  <b-container
    fluid="md"
    class="square-removecard-success"
  >
    <b-row>
      <b-col class="remove-card-success-header">
        <div class="title">
          <font-awesome-icon
            icon="check-circle"
            class="icon success-icon"
            size="2x"
            fixed-width
          />
          Remove Card Details Success
        </div>
        <div class="message">
          The stored card details have been successfully removed from your account.
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="removed-card-details">
          <h3>Removed card details</h3>
          <div>
            <span class="label">Cardholder Name</span>
            <span
              class="value"
              data-cy="cardholder-name"
            >{{ cardholder_name }}
            </span>
          </div>
          <div>
            <span class="label">Card type</span>
            <span
              class="value"
              data-cy="card-type"
            >{{ cardType }}
            </span>
          </div>
          <div>
            <span class="label">Card expiry date</span>
            <span
              class="value"
              data-cy="card-expdate"
            >{{ cardExpDate }}</span>
          </div>
          <div>
            <span class="label">Card Number</span>
            <span
              class="value"
              data-cy="card-number"
            > {{ cardNumber }} </span>
          </div>
        </div>
      </b-col>
    </b-row>
    <square-response-debug-wrapper
      v-if="debug"
      :debug-data="response"
    />
  </b-container>
</template>

<script>
import CommonTxnFields from './common-txn-fields'
import DebugWrapper from './debug.vue'

export default {
  name: 'square-removecard-success',
  components: {
    'square-response-debug-wrapper': DebugWrapper
  },
  mixins: [
    CommonTxnFields
  ],
  props: {
    debug: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    response: function() {
      const result = this.$store.getters['square/processingResult']
      console.log('Remove Card Success - Processing Result:', result)
      return result
    },
    cardholder_name: function() {
      console.log('Remove Card Success - Card object:', this.response?.card)
      return this.response?.card?.cardholder_name || 'Unknown'
    },
    cardType: function() {
      return this.response?.card?.card_brand || 'Unknown'
    },
    cardExpDate: function() {
      const month = this.response?.card?.exp_month || 12
      const year = this.response?.card?.exp_year || 2025
      return `${month.toString().padStart(2, '0')}/${year % 100}`
    },
    cardNumber: function() {
      const bin = this.response?.card?.bin || '1234'
      const last4 = this.response?.card?.last_4 || '5678'

      // Format as XXXX XXXX XXXX XXXX (groups of 4)
      const cardNumber = bin + 'X'.repeat(6) + last4
      return cardNumber.replace(/(.{4})/g, '$1 ').trim()
    }
  }
}
</script>

<style lang="scss" scoped>
  .square-removecard-success {
    .remove-card-success-header {
      .title {
        font-size: 2.2rem;
        margin-bottom: 1rem;
      }
      .message {
        font-size: 1rem;
        margin-bottom: 1rem;
      }
    }
    .label {
      display: inline-block;
      width: 200px;
    }
    .success-icon {
      color: green;
    }
  }
</style>
